/** Local HH:mm for `<input type="time">`. */
export function currentTimeValue(date = new Date()) {
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
}

/** Open the native time picker when the browser supports it. */
export function openNativeTimePicker(input) {
  if (!input) return;
  input.focus();
  if (typeof input.showPicker === "function") {
    try {
      input.showPicker();
    } catch {
      /* showPicker throws if the input is not user-activated or unsupported */
    }
  }
}
